import i18n from './i18n'
import languageService from '../services/api/LanguageService'

var Translation = function () {
  var loadedLanguages = []
  var supportedTranslations = []

  var setI18nLanguage = function (lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
  }

  return {
    setLanguage: async function (cultureCode) {
      await languageService.getTranslation(cultureCode)
        .then(response => {
          var translations = {}
          for (var t = 0; t < response.data.length; t++) {
            translations[response.data[t].Key] = response.data[t].Value
          }

          i18n.setLocaleMessage(cultureCode, translations)
          loadedLanguages.push(cultureCode)
          localStorage.setItem('locale', cultureCode)
          return setI18nLanguage(cultureCode)
        }).catch(e => {
          console.log(e)
        })
      return Promise.resolve(setI18nLanguage(cultureCode))
    },
    setSupportedLanguages: function (cultureCodes) {
      supportedTranslations = cultureCodes
    },
    getCurrentLanguage: function () {
      return i18n.locale
    },
    getSupportedTranslations: function () {
      return supportedTranslations
    }
  }
}

export default new Translation()



// WEBPACK FOOTER //
// ./src/i18n/Translation.js